import { useEffect, useMemo, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { PageHeader, Surface, Empty } from "../components/Primitives";
import { ArrowLeftRight } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function Transfers() {
  const { user } = useAuth();
  const canEdit = user?.role === "admin" || user?.role === "user";
  const [rows, setRows] = useState([]);
  const [products, setProducts] = useState([]);
  const [sites, setSites] = useState([]);
  const [form, setForm] = useState({ product_id:"", from_site_id:"", to_site_id:"", quantity:1, note:"" });

  const load = async () => {
    const [t, p, s] = await Promise.all([api.get("/transfers"), api.get("/products"), api.get("/sites")]);
    setRows(t.data); setProducts(p.data); setSites(s.data);
  };
  useEffect(()=>{load();},[]);

  const productMap = useMemo(()=>Object.fromEntries(products.map(p=>[p.id, p])), [products]);
  const siteMap = useMemo(()=>Object.fromEntries(sites.map(s=>[s.id, s])), [sites]);

  const submit = async e => {
    e.preventDefault();
    if (form.from_site_id === form.to_site_id) return toast.error("Les sites source et destination doivent différer");
    try { await api.post("/transfers", { ...form, quantity: Number(form.quantity) });
      toast.success("Transfert effectué");
      setForm({ product_id:"", from_site_id:"", to_site_id:"", quantity:1, note:"" }); load();
    } catch(e){ toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div className="space-y-6">
      <PageHeader title="Transferts entre sites" subtitle="Mouvements inter-sites"/>

      {canEdit && (
        <Surface title="Nouveau transfert">
          <form onSubmit={submit} className="p-5 grid grid-cols-2 md:grid-cols-5 gap-4">
            <div className="md:col-span-2"><label className="label-mono block mb-1.5">Produit</label>
              <select data-testid="trf-product" required className="input-base" value={form.product_id} onChange={e=>setForm({...form,product_id:e.target.value})}>
                <option value="">— Choisir —</option>
                {products.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
            </div>
            <div><label className="label-mono block mb-1.5">Source</label>
              <select data-testid="trf-from" required className="input-base" value={form.from_site_id} onChange={e=>setForm({...form,from_site_id:e.target.value})}>
                <option value="">—</option>{sites.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </div>
            <div><label className="label-mono block mb-1.5">Destination</label>
              <select data-testid="trf-to" required className="input-base" value={form.to_site_id} onChange={e=>setForm({...form,to_site_id:e.target.value})}>
                <option value="">—</option>{sites.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </div>
            <div><label className="label-mono block mb-1.5">Quantité</label><input data-testid="trf-qty" type="number" min="1" required className="input-base" value={form.quantity} onChange={e=>setForm({...form,quantity:e.target.value})}/></div>
            <div className="col-span-full flex gap-2"><button data-testid="submit-trf" type="submit" className="btn-primary flex items-center gap-2"><ArrowLeftRight size={14}/>Transférer</button></div>
          </form>
        </Surface>
      )}

      <Surface title="Historique des transferts">
        {rows.length === 0 ? <Empty/> : (
          <table className="data-table">
            <thead><tr><th>Date</th><th>Produit</th><th>Source</th><th>Destination</th><th>Qté</th></tr></thead>
            <tbody>
              {rows.map(r => (
                <tr key={r.id}>
                  <td className="font-data text-[var(--text-muted)] text-xs">{r.created_at?.slice(0,16).replace("T"," ")}</td>
                  <td>{productMap[r.product_id]?.name || r.product_id}</td>
                  <td className="text-[var(--text-muted)]">{siteMap[r.from_site_id]?.name}</td>
                  <td className="neon-text-cyan">{siteMap[r.to_site_id]?.name}</td>
                  <td className="font-data">{r.quantity}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Surface>
    </div>
  );
}
